import React, { Component } from 'react';

//import pages
import Home from '../Home'
import Features from '../Features'
import About from '../About'
import Investment from '../Investment'
import Contact from '../Contact'
import People from '../People'
import Footer from '../Footer'
import Navbar from '../Navbar'

import './fullpageComponentStyles.css'

class FullPageComponents extends Component {
  render() {    
    return (
        <div>
          <section id="nav">
            <Navbar />
          </section>
          <section id="home" className="homeDiv">
            <Home />
          </section>
          <section id="features">
            <Features />
          </section>
          <section id="about" hidden={false}>
            <About />
          </section>
          <section id="people">
            <People />
          </section>
          <section id="investment">
            <Investment />
          </section>
          <section id="contact" className="contactDiv">
            <Contact />
          </section>
          <section id="footer">
            <Footer />
          </section>
        </div>
    );
  }
}

export default FullPageComponents;



// WEBPACK FOOTER //
// ./src/components/FullPageComponents/index.js